import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, messageErreur } from "@/lib/api";
import { useRefs, versOptions, listeOptions } from "@/lib/referentiels";
import { Champ } from "@/components/commun";
import { ChoixListe } from "@/pages/parametres/ChoixListe";

const VIDE = { prenom: "", nom: "", telephone: "", email: "", code_postal: "", ville: "", type: "particulier", organisation: "", operation: "Pompe à chaleur", montant_estime: "", source: "Formulaire" };

export const NouvelleFicheDialog = ({ ouvert, setOuvert }) => {
  const refs = useRefs();
  const navigate = useNavigate();
  const [f, setF] = useState(VIDE);
  const m = (k) => (e) => setF({ ...f, [k]: e?.target ? e.target.value : e });
  const creer = async (e) => {
    e.preventDefault();
    try {
      const organisation = f.organisation.trim() ? { nom: f.organisation, type: f.type === "collectivite" ? "mairie" : "entreprise", code_postal: f.code_postal, ville: f.ville } : null;
      const { data } = await api.post("/fiches", {
        operation: f.operation, montant_estime: Number(f.montant_estime || 0), source: f.source, organisation,
        contact: { prenom: f.prenom, nom: f.nom, telephones: [f.telephone], email: f.email, code_postal: f.code_postal, ville: f.ville, type: f.type, source: f.source },
      });
      toast.success("Fiche créée, premier appel planifié.");
      setOuvert(false); setF(VIDE); navigate(`/fiches/${data.id}`);
    } catch (err) { toast.error(messageErreur(err)); }
  };
  return (
    <Dialog open={ouvert} onOpenChange={setOuvert}>
      <DialogContent className="at-popover max-w-[calc(100vw-24px)] sm:max-w-lg max-h-[90vh] overflow-y-auto" data-testid="new-fiche-dialog">
        <DialogHeader><DialogTitle>Nouvelle fiche</DialogTitle></DialogHeader>
        <form onSubmit={creer} className="space-y-3">
          <div className="grid sm:grid-cols-2 gap-2">
            <Champ label="Prénom" id="nf-prenom" value={f.prenom} onChange={m("prenom")} data-testid="new-fiche-prenom" />
            <Champ label="Nom" id="nf-nom" required value={f.nom} onChange={m("nom")} data-testid="new-fiche-nom" />
          </div>
          <div className="grid sm:grid-cols-2 gap-2">
            <Champ label="Téléphone" id="nf-tel" type="tel" value={f.telephone} onChange={m("telephone")} data-testid="new-fiche-telephone" />
            <Champ label="E-mail" id="nf-mail" type="email" value={f.email} onChange={m("email")} data-testid="new-fiche-email" />
          </div>
          <div className="grid grid-cols-[110px_1fr] gap-2">
            <Champ label="Code postal" id="nf-cp" value={f.code_postal} onChange={m("code_postal")} data-testid="new-fiche-cp" />
            <Champ label="Ville" id="nf-ville" value={f.ville} onChange={m("ville")} data-testid="new-fiche-ville" />
          </div>
          <ChoixListe label="Type de contact" valeur={f.type} onChange={m("type")} options={versOptions(refs?.types_contact)} testId="new-fiche-type" />
          <Champ label="Organisation (mairie, entreprise… facultatif)" id="nf-org" value={f.organisation} onChange={m("organisation")} data-testid="new-fiche-organisation" />
          <div className="grid sm:grid-cols-2 gap-2">
            <ChoixListe label="Opération" valeur={f.operation} onChange={m("operation")} options={listeOptions(refs?.operations)} testId="new-fiche-operation" />
            <Champ label="Montant estimé (€)" id="nf-montant" type="number" value={f.montant_estime} onChange={m("montant_estime")} data-testid="new-fiche-montant" />
          </div>
          <ChoixListe label="Source" valeur={f.source} onChange={m("source")} options={listeOptions(refs?.sources)} testId="new-fiche-source" />
          <button type="submit" className="at-btn at-btn-primary w-full" data-testid="new-fiche-submit">Créer la fiche</button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
